<template>
    <div>
        <app-wysiwyg
            label="Bild Titel"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.title'
            "
            :data-default="{ type: 'textpicker' }"
            :textpicker-namespace="['gallery/1/title', 'gallery/2/title', 'gallery/3/title']"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Bild Untertitel"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.subtitle'
            "
            :data-default="{ type: 'textpicker' }"
            :textpicker-namespace="[
                'gallery/1/subtitle',
                'gallery/2/subtitle',
                'gallery/3/subtitle'
            ]"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Bild Teaser"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.text'
            "
            :data-default="{ type: 'textpicker' }"
            :textpicker-namespace="['gallery/1/text', 'gallery/2/text', 'gallery/3/text']"
            :maxlength="1024"
        ></app-wysiwyg>

        <app-filepicker
            label="Bild"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.image'
            "
            accept=".jpg,.png,.gif"
            :show-focus="
                !['auto'].includes(getProp('tecpage.user.modules.' + moduleId + '.data.type'))
            "
            :show-transparency="true"
            :show-scaling-mode="
                !['auto'].includes(getProp('tecpage.user.modules.' + moduleId + '.data.type'))
            "
        ></app-filepicker>

        <app-link
            label="Button 1"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.link'
            "
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.link2'
            "
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.slides.' + listitemId + '.data.link3'
            "
        ></app-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import Link from '@/components/assorted/Link.vue';
import { EventBus } from '@/helpers/event-bus';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R029'),
            help: this.$helpers.uiText('R030'),
            removeText: this.$helpers.uiText('R031')
        });
        EventBus.$emit('slider-goto', {
            id: this.listitemId
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-filepicker': Filepicker,
        'app-link': Link
    }
};
</script>
